import * as React from 'react';
import { LegendChip } from './components/LegendChip';
import { LegendContainer, ActualEstimateContainer, ActualEstimateLabel } from './Legend.styles';
import { sortSeriesByName } from '../../utils/sortByName';
import { Crosshatch } from '../../GroupedBar/components/Crosshatch';
import { color } from '../../../constants';
function ActualEstimateIndicator(_a) {
    var _b = _a.size, size = _b === void 0 ? 11 : _b, _c = _a.crossHatch, crossHatch = _c === void 0 ? false : _c, _d = _a.backgroundColor // fallback color
    , backgroundColor = _d === void 0 ? color.theme.typography.subdued : _d // fallback color
    ;
    return (React.createElement("svg", { width: size, height: size, style: { backgroundColor: backgroundColor } },
        crossHatch && (React.createElement(Crosshatch, { id: 'crosshatch', color: "#fff", strokeWidth: 2 })),
        React.createElement("rect", { width: size, height: size, fill: crossHatch ? "url(#crosshatch)" : backgroundColor })));
}
export function Legend(_a) {
    var series = _a.series, activeSet = _a.activeSet, onToggle = _a.onToggle, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, accessors = _a.accessors, colorScheme = _a.colorScheme, marginLeft = _a.marginLeft, marginRight = _a.marginRight, legendFormat = _a.legendFormat;
    var _b = React.useState(activeSet), activeSeries = _b[0], setActiveSeries = _b[1];
    var sorted = React.useMemo(function () { return sortSeriesByName(Object.values(series), accessors); }, [series]);
    var handleMouseEnter = React.useCallback(function (id) { return function () {
        if (onMouseEnter !== undefined)
            onMouseEnter(id);
    }; }, [series, onMouseEnter]);
    var onLegendClick = React.useCallback(function (id) {
        var clone = new Set(activeSeries);
        if (clone.has(id)) {
            clone.delete(id);
        }
        else {
            clone.add(id);
        }
        setActiveSeries(clone);
        onToggle(clone, id);
    }, [activeSeries]);
    var maxLegendColor = colorScheme(accessors.key(sorted[sorted.length - 1]));
    return (React.createElement(React.Fragment, null,
        React.createElement(LegendContainer, { className: "Legend--Container", marginLeft: marginLeft, marginRight: marginRight }, sorted.map(function (s) {
            var _a, _b;
            var key = accessors.key(s);
            var label = legendFormat !== undefined
                ? legendFormat(accessors.name(s))
                : accessors.name(s);
            var subLabel = (_a = accessors.group) === null || _a === void 0 ? void 0 : _a.call(accessors, s);
            var legendColor = colorScheme(key);
            return (React.createElement(LegendChip, { key: key, active: activeSet.has(key), color: legendColor, label: label, subLabel: subLabel, onMouseEnter: handleMouseEnter(key), onMouseLeave: onMouseLeave, onClick: function () { return onLegendClick(key); }, status: (_b = accessors.valid) === null || _b === void 0 ? void 0 : _b.call(accessors, s) }));
        })),
        React.createElement(ActualEstimateContainer, { style: { marginLeft: marginLeft } },
            React.createElement(ActualEstimateLabel, null,
                React.createElement(ActualEstimateIndicator, { backgroundColor: maxLegendColor }),
                "Actual"),
            React.createElement(ActualEstimateLabel, null,
                React.createElement(ActualEstimateIndicator, { backgroundColor: maxLegendColor, crossHatch: true }),
                "Estimated"))));
}
//# sourceMappingURL=Legend.js.map